import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import AuthGuard from "./AuthGuard";
import Unauthorized from "./Unauthorized";

// Box Elder/Union stays open to all authenticated users (legacy behavior),
// EXCEPT users scoped to the Plumb Ditch page. Admins/Developers keep access
// even if they also hold the Plumb Ditch role (e.g. for testing).
const PlumbDitchExclusion = ({ children }) => {
  const { user } = useAuth0();

  const roles = user?.[`${process.env.REACT_APP_AUDIENCE}/roles`] || [];
  const isAdmin = roles.some((x) => ["Administrator", "Developer"].includes(x));
  const isPlumbOnly = !isAdmin && roles.includes("Plumb Ditch");

  if (isPlumbOnly) return <Unauthorized />;

  return children;
};

// Preserves AuthGuard's authentication requirement, then applies the exclusion.
const BoxElderGuard = ({ children }) => (
  <AuthGuard>
    <PlumbDitchExclusion>{children}</PlumbDitchExclusion>
  </AuthGuard>
);

export default BoxElderGuard;
